import {
    Collapse,
    initTE,
  } from "tw-elements";
  
  initTE({ Collapse });